export const getProfileCompletionPercentage = (member) => {
    const requiredFields = [
        "First_Name", "Last_Name", "Mobile_Number", "Email",
        "DOB", "Occupation", "Address", "City", "District", "State", "Pincode",
         "ID_Proof_Type", "ID_Proof_Number",
        "Pan_Card", "Pan_Number", "Marital_Status",
        "Family_Details"
    ];

    const total = requiredFields.length;
    const filled = requiredFields.filter((field) => member[field] && member[field].toString().trim() !== "").length;
    return Math.round((filled / total) * 100);
};
